import React, { useEffect, useState, useRef, useCallback } from "react";
import "./index.css";
import { Box, Tooltip, tooltipClasses } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BeneViewAllCard from "../../BeneficiaryAccount/BeneViewAllCard";
import AllStatusTypeButton from "../../BeneficiaryAccount/AllStatusTypeButton";
import BeneAccFilterSidebar from "../../BeneficiaryAccount/BeneAccFilterSidebar";
import BeneAccListView from "../../BeneficiaryAccount/BeneAccListView";
import AllStatusTypeButtonMob from "../../BeneficiaryAccount/AllStatusTypeButton/AllStatusTypeButtonMob.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import SearchBar from "../../../../components/_utils/search/SearchBar";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import { checkUsertoken } from "../../../../redux/features/login/login";
import {
  beneViewAllAcc,
  setToggle,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { getRefreshTokenNew } from "../../../../redux/features/refreshToken/refreshToken.js";
import noaccount from "../../../../assets/Graphics/No transaction found.svg";
import dataLoading from "../../../../assets/Beneficiary Icons/inputloder.gif";
import closeBtnImg from "../../../../assets/CloseIcons/close_with_blue_circle.svg";
import rentalImg from "../../../../assets/CategoryIcons/rental.svg";
import arrowForward from "../../../../assets/ArrowsIcons/arrow_right_blue.svg";
import arrowdown from "../../../../assets/ArrowsIcons/arrow_down_white.svg";
import ArrowDown8 from "../../../../assets/ArrowsIcons/arrow_down_blue.svg";
import ArrowUp4 from "../../../../assets/ArrowsIcons/arrow_up_blue.svg";
import FilterBlue from "../../../../assets/FilterSearchIcons/filter_blue.svg";
import Filter from "../../../../assets/FilterSearchIcons/filter.svg";
import search_blue from "../../../../assets/FilterSearchIcons/search_blue.svg";
import search_white from "../../../../assets/FilterSearchIcons/search_white.svg";
import ArrowLeft from "../../../../assets/ArrowsIcons/ChevronLeftWhite.svg";
import ListBlue from "../../../../assets/ViewIcons/list_view_blue.svg";
import ListWhite from "../../../../assets/ViewIcons/list_view_white.svg";
import GridBlue from "../../../../assets/ViewIcons/Grid view blue.svg";
import GridWhite from "../../../../assets/ViewIcons/Grid view white.svg";
import Cancel from "../../../../assets/ViewAllTransactions/Clear filter.png";
import arrowup from "../../../../assets/ArrowsIcons/arrow_up_white.svg";
import { resetToggle } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import Loader from "../../../../components/Loader/Index.jsx";

const InternalAccountViewAll = ({
  typepop,
  onClosepop,
  handleButtonClick,
  associateAccount,
  associatepanNumber,
  associateIFSC,
  associateaccountNumber,
  setOpenInternalAssociate,
  setOpenBeneAssociate,
  beneAccountId,
  accountType,
  flow,
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  onClose,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //variable section
  const internalAccount = "internalAccount";
  const updatedStatus = location.state ? location.state.approvalStatus : "";
  const approvalStatus = typepop === "popup" ? "all" : updatedStatus;

  //useref section
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const dateRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const searchBarRefAccm = useRef(null);
  const searchBarRefAccm2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const sidebarButtonRef = useRef(null);
  const lastElementRef = useRef();
  const sidebarRef = useRef(null);
  const sidebarRefm = useRef(null);

  //useState section
  const [balanceType, setBalanceType] = useState("Pan");
  const [searchPanText, setSearchPanText] = useState(
    associateAccount || associateTxn || BeneTxnAssocAcct
      ? associatepanNumber
      : ""
  );
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showSearchBarm, setShowSearchBarm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(approvalStatus);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpenm, setIsSidebarOpenm] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [searchUserText, setSearchUserText] = useState("");
  const [initCategory, setInitCategory] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [searchIfscText, setSearchIfscText] = useState("");
  const [isIfsc, setIsIfsc] = useState("");
  const [panNumber, setPanNumber] = useState(associatepanNumber || "");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [searchAccountText, setSearchAccountText] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isPopoverOpenm, setIsPopoverOpenm] = useState(false);
  const [isStatusSelected, setIsStatusSelected] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([50, 100]);
  const [selectedValue, setSelectedValue] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [callFilter, setcallFilter] = useState(null);
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= 3840 ? 192 : window.innerWidth >= 2560 ? 102 : 50
  );
  const [getFilterStatus, setFilterStatus] = useState();
  const [isInternalFilter, setIsInternalFilter] = useState(true);

  //Selector section
  const { beneViewAllAccData, storedPage, toggle } = useSelector(
    (state) => state.beneAllVerification
  );

  //Write Function section
  const getIcon = () => {
    if (showSearchBar) {
      return searchUserText !== "" ? ArrowUp4 : arrowup;
    } else {
      return searchUserText !== "" ? ArrowDown8 : arrowdown;
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar && !isSidebarOpen) {
        dispatch(setToggle(newToggleValue));
      }

      setCurrentPage(1);
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(storedPage));
    toggleDropdown();
  };

  const handleFilterCategory = (selectedCategoryName) => {
    setCurrentCategory(selectedCategoryName);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
    setShowDatePicker(false);
  };

  const toggleSidebarm = () => {
    setIsSidebarOpenm((prevState) => !prevState);
    setShowDatePicker(false);
  };

  const handleClickOutside = (event) => {
    if (event.target.className == "acc_black_div") {
      setIsSidebarOpen(false);
    }
    if (sidebarRefm.current && !sidebarRefm.current.contains(event.target)) {
      setIsSidebarOpenm(false);
    }
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback((event) => {
    setIsWheelScrolling(true);
  }, []);

  const getAccStatus = (item) => {
    setCurrentStatus(item);
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!currentCategory ||
        !!(startDateFilter && endDateFilter) ||
        !!accountNumber ||
        !!panNumber ||
        !!isIfsc
    );
  };

  const getArrowIcon = (isSidebarOpen, isFilterApplied) => {
    if (isSidebarOpen) {
      return isFilterApplied ? ArrowUp4 : arrowup;
    } else {
      return isFilterApplied ? ArrowDown8 : arrowdown;
    }
  };

  const handleFilterSticker = () => {
    setCurrentCategory("");
    setInitCategory("");
  };

  const handleFilterPanSticker = () => {
    setPanNumber("");
    setSearchPanText("");
  };

  const handleFilterAccountSticker = () => {
    setAccountNumber("");
    setSearchAccountText("");
    setIsIfsc("");
    setSearchIfscText("");
  };

  const handleFilterDateSticker = () => {
    setStartDate("");
    setStartDateFilter("");
    setEndDateFilter("");
    setEndDate("");
  };

  function handleWindowSizeChange() {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1140 && screenWidth < 2560) {
      setPageSize(50);
    } else if (screenWidth >= 2560 && screenWidth < 3840) {
      setPageSize(102);
    } else if (screenWidth >= 3840) {
      setPageSize(192);
    }
  }

  const handlePaste = (e) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text").trim();

    const isPhoneNumber = /^\+\d/.test(pastedText);

    if (isPhoneNumber) {
      pastedText = pastedText.replace(/^\+\d{1,3}|[^0-9]/g, "");
    } else {
      setSearchUserText(pastedText);
      setSearchTerm(pastedText);
    }

    setSearchUserText(pastedText);
    setSearchTerm(pastedText);
  };

  const handleAccPaste = (e) => {
    e.preventDefault();
    setAccountNumber(e.target.value);
  };

  const handleFilterDateRange = (startDate, endDate) => {
    setStartDateFilter(startDate);
    setEndDateFilter(endDate);
  };

  const handleAccountSearch = (selectedAccNumber) => {
    setAccountNumber(selectedAccNumber);
  };

  const handlePanSearch = (selectedPanNumber) => {
    setAccountNumber(selectedPanNumber);
  };

  const handleIfscSearch = (selectedIfscNumber) => {
    setIsIfsc(selectedIfscNumber);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const isFilterActive =
    currentCategory !== "" ||
    panNumber !== "" ||
    accountNumber !== "" ||
    isIfsc !== "" ||
    (startDateFilter &&
      endDateFilter &&
      startDateFilter !== 0 &&
      endDateFilter !== 0 &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter)));

  const filteredData = accumulatedData;

  //useEffect section
  useEffect(() => {
    if (callFilter) {
      callFilter();
    }
  }, [balanceType]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setCurrentPage((prevPage) => {
      if (newTotalPages === 0) {
        return 1;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        if (currentPage === 1) {
          setLoading(true);
        }

        let queryParams = {
          page_no: currentPage,
          page_size: pageSize,
          // search_string: searchUserText,
        };

        const addParamsBasedOnSelection = () => {
          if (currentStatus !== "all") {
            queryParams.approval_status = currentStatus;
          }
          if (currentCategory !== "") {
            queryParams.categoryName = currentCategory;
          }
          if (
            startDateFilter !== "" &&
            endDateFilter !== "" &&
            startDateFilter !== 0 &&
            endDateFilter !== 0 &&
            !isNaN(Number(startDateFilter)) &&
            !isNaN(Number(endDateFilter))
          ) {
            queryParams.start_date = startDateFilter;
            queryParams.end_date = endDateFilter;
          }
          if (accountNumber !== "") {
            queryParams.bank_account_no = accountNumber;
          }

          if (panNumber !== "") {
            queryParams.pan = panNumber;
          }
          if (searchUserText !== "") {
            queryParams.search_string = searchUserText;
          }
          if (isIfsc !== "") {
            queryParams.ifsc = isIfsc;
          }
          if (
            internalAccount === "internalAccount" ||
            accountType === "internal" ||
            flow === "internalTxn" ||
            associateTxn === "associateTxn"
          ) {
            queryParams.type = "internalAccount";
          }
        };
        addParamsBasedOnSelection();
        dispatch(checkUsertoken());
        const response = await dispatch(beneViewAllAcc(queryParams));
        const newData = response?.payload?.internal_accounts || [];
        setMainData(response?.payload);
        setAccumulatedData(newData);
        setTotalCount(
          associateAccount
            ? response?.payload?.internal_accounts?.filter((item) => {
                return item?.bank_acc_no != associateaccountNumber;
              }).length
            : response?.payload?.total_count || 0
        );

        setLoading(false);
      } catch (error) {
        setLoading(false);
        (() => {})();
      }
    }
    fetchData();
  }, [
    dispatch,
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    panNumber,
    isIfsc,
  ]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isSidebarOpen, getFilterStatus]);

  useEffect(() => {
    if (isSidebarOpenm) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpenm, getFilterStatus]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
  ]);

  useEffect(() => {
    dispatch(checkUsertoken());
    dispatch(getRefreshTokenNew());
    dispatch(resetToggle());

    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
        setShowDatePicker(false);
      }

      if (
        searchBarRefAccm.current &&
        !searchBarRefAccm.current.contains(event.target) &&
        searchBarRefAccm2.current &&
        !searchBarRefAccm2.current.contains(event.target)
      ) {
        setShowSearchBarm(false);
      }

      if (
        searchBarRefAccm.current &&
        !searchBarRefAccm.current.contains(event.target) &&
        searchBarRefAccm2.current &&
        !searchBarRefAccm2.current.contains(event.target)
      ) {
        setShowSearchBarm(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (approvalStatus && approvalStatus !== "all") {
      setIsStatusSelected(true);
    } else {
      setIsStatusSelected(false);
    }

    setCurrentStatus(approvalStatus);
    setCurrentPage(1);

    handleWindowSizeChange();

    window.addEventListener("resize", handleWindowSizeChange);
    document.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div id="webviewd">
        <>
          <div
            id="beneScrollContainer"
            className={`bg-custom-appBack flex flex-col h-screen`}
            style={{
              position: "relative",
              overflowY: isSidebarOpen || isPopoverOpen ? "hidden" : "",
            }}
          >
            {isPopoverOpen && <div className="acc_black_div"></div>}
            {isSidebarOpen && <div className="acc_black_div"></div>}

            {
              <div
                style={{
                  zIndex: isSidebarOpen || isPopoverOpen ? "9" : "9999",
                  width: typepop === "popup" ? "96%" : "100%",
                  bottom: typepop === "popup" ? "4%" : "0%",
                  borderRadius: "0",
                  borderBottomRightRadius: typepop === "popup" ? "20px" : "0px",
                  borderBottomLeftRadius: typepop === "popup" ? "20px" : "0px",
                }}
                className="fixed w-full bg-Blue_4 h-[50px]"
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  accountType={accountType}
                  totalCount={totalCount}
                />
              </div>
            }
            <div
              className="top_line_of_div"
              style={{
                display: typepop === "popup" ? "flex" : "none",
                // flexDirection: typepop === "popup" ? "flex" : "none",
              }}
            >
              <div className="top_line_of_div_section">
                {accountType === "internal" ||
                accountType === "beneficiary" ||
                BeneTxnAssocAcct ||
                associateTxn === "associateTxn" ? (
                  <h3>Associated accounts</h3>
                ) : flow === "internalTxn" ? (
                  <h3>Select destination account</h3>
                ) : (
                  <h3>Select beneficiary account:</h3>
                )}

                {accountType === "internal" ? (
                  <p className="w-[419px] h-[16px] font-open-sans text-[12px] leading-[16.34px] text-Primary_white">
                    The accounts listed below are linked to the selected
                    internal account.
                  </p>
                ) : accountType === "beneficiary" ? (
                  <p className="w-[419px] h-[16px] font-open-sans text-[12px] leading-[16.34px] text-Primary_white">
                    The accounts listed below are linked to the selected
                    beneficiary account.
                  </p>
                ) : (
                  <p className="w-[419px] h-[16px] font-open-sans text-[12px] leading-[16.34px] text-Primary_white">
                    Only active (pending & approved) accounts are enabled for
                    selection.
                  </p>
                )}
              </div>
              {flow !== "internalTxn" &&
              (associateAccount || BeneTxnAssocAcct) &&
              accountType !== "internal" ? (
                <div className="flex gap-5">
                  <div
                    className="flex items-center w-[158px] my-auto px-[5px] gap-x-[5px] mr-[10px] h-[30px] rounded-[10px] bg-Blue_5 relative cursor-pointer"
                    style={{
                      display:
                        accountType === "CreateDestAssociated"
                          ? "none"
                          : "auto",
                    }}
                  >
                    <div
                      style={{
                        top: "5px",
                        left: balanceType === "Pan" ? "5px" : "80px",
                        transition: "0.2s all ease-in-out",
                      }}
                      className="absolute w-[74px] h-[20px] rounded-[5px] bg-Primary_white"
                    ></div>

                    {/* PAN Button */}
                    <div
                      onClick={() => {
                        setBalanceType("Pan");
                        setSearchPanText(associatepanNumber);
                        setSearchIfscText("");
                        setSearchAccountText("");
                        setPanNumber(associatepanNumber);
                        setAccountNumber("");
                        setIsIfsc("");
                        handleFilterDateSticker();
                        setSearchUserText("");
                        setSearchTerm("");
                      }}
                      style={{
                        fontWeight: balanceType === "Pan" ? "600" : "400",
                        color:
                          balanceType === "Pan"
                            ? "var(--Primary_black)"
                            : "var(--Primary_white)",
                      }}
                      className="relative w-[74px] h-[20px] rounded-[5px] text-[12px] flex justify-center items-center z-[1] itxn"
                    >
                      PAN
                      <div className="itxn_card_hover_overlay"></div>
                    </div>

                    {/* Bank Button */}
                    <div
                      onClick={() => {
                        setBalanceType("Bank");
                        setSearchIfscText(associateIFSC);
                        setSearchAccountText(associateaccountNumber);
                        setSearchPanText("");
                        setPanNumber("");
                        handleFilterDateSticker();
                        setSearchUserText("");
                        setSearchTerm("");
                        setAccountNumber(associateaccountNumber);
                        setIsIfsc(associateIFSC);
                      }}
                      style={{
                        fontWeight: balanceType === "Bank" ? "600" : "400",
                        color:
                          balanceType === "Bank"
                            ? "var(--Primary_black)"
                            : "var(--Primary_white)",
                      }}
                      className="relative w-[74px] h-[20px] rounded-[5px] text-[12px] flex justify-center items-center z-[1] itxn"
                    >
                      Bank
                      <div className="itxn_card_hover_overlay"></div>
                    </div>
                  </div>

                  {/* Cancel Button */}
                  <div
                    className="top_cancel_div_pop"
                    onClick={() => {
                      if (typepop === "popup") {
                        onClosepop();
                      }
                    }}
                  >
                    <img src={Cancel} alt="cancel" />
                  </div>
                </div>
              ) : (
                <div
                  className="top_cancel_div_pop"
                  onClick={() => {
                    if (typepop === "popup") {
                      onClosepop();
                    }
                  }}
                >
                  <img src={Cancel} alt="cancel" />
                </div>
              )}
            </div>

            <div
              className="internal_account_div_container"
              style={{
                height: showSearchBar ? "245px" : "170px",
                transition: showSearchBar
                  ? "all 0.2s ease-in"
                  : "all 0.2s ease-in",
                top: typepop === "popup" ? "4%" : "0",
                borderTopRightRadius: typepop === "popup" ? "20px" : "0",
                borderTopLeftRadius: typepop === "popup" ? "20px" : "0",
                width: typepop === "popup" ? "96%" : "100%",
              }}
            >
              <div
                className={"internal_account_div"}
                style={{
                  position: isPopoverOpen ? "relative" : "",
                }}
              >
                <div className="acc_left">
                  <AllStatusTypeButton
                    getAccStatus={getAccStatus}
                    selectedStatus={currentStatus}
                    setPage={setCurrentPage}
                    setIsPopoverOpen={setIsPopoverOpen}
                    isPopoverOpen={isPopoverOpen}
                    isStatusSelected={isStatusSelected}
                    setIsStatusSelected={setIsStatusSelected}
                    setShowSearchBar={setShowSearchBar}
                    isSidebarOpen={isSidebarOpen}
                    showSearchBar={showSearchBar}
                    getFilterStatus={getFilterStatus}
                    setIsSidebarOpen={setIsSidebarOpen}
                    loading={loading}
                    internalAccount={internalAccount}
                  />
                  {(internalAccount === "internalAccount" ||
                    associateTxn === "associateTxn" ||
                    flow === "internalTxn") && (
                    <div className="totalCount">
                      <div className="totalCountDiv">
                        <span
                          style={{
                            display: "inline-block",
                            fontSize: "14px",
                            paddingRight: "5px",
                          }}
                        >
                          {associateTxn === "associateTxn"
                            ? filteredData.filter((item) => {
                                return (
                                  item.bank_acc_no != associateaccountNumber
                                );
                              }).length
                            : totalCount}
                        </span>
                      </div>
                      <p
                        style={{
                          width: "250px",
                          height: "17px",
                          marginTop: "5px",
                          font: "normal normal normal 12px/17px Open Sans",
                          color: "var(--Primary_grey)",
                        }}
                      >
                        Total account
                      </p>
                    </div>
                  )}
                </div>

                <div className="acc_right">
                  <>
                    <Tooltip
                      componentsProps={{
                        popper: {
                          sx: {
                            [`& .${tooltipClasses.tooltip}`]: {
                              backgroundColor: (theme) =>
                                theme.palette.common.black,
                            },
                            zIndex: "2147483647 !important",
                          },
                        },
                      }}
                      title="Search"
                    >
                      <div
                        ref={searchBarRefAcc}
                        className={`beneTxn_viewAll_search_div_acc ${
                          searchUserText !== "" ? "searched" : ""
                        } hover:${!isSidebarOpen ? "bg-Blue_7" : ""}`}
                        style={{
                          opacity: isSidebarOpen ? "0.6" : "1",
                          cursor: isSidebarOpen ? "default" : "pointer",
                        }}
                        onClick={() => {
                          if (!isSidebarOpen) {
                            setShowSearchBar(!showSearchBar);
                          } else if (isSidebarOpen) {
                            setIsSidebarOpen(false);
                          }
                        }}
                      >
                        <img
                          className="bene_txn_search-image"
                          src={searchUserText ? search_blue : search_white}
                          alt=""
                        />

                        <img
                          src={getIcon()}
                          alt=""
                          className="w-[12px] h-[12px]"
                        />
                      </div>
                    </Tooltip>
                    {showSearchBar && (
                      <SearchBar
                        showSearchBar={showSearchBar}
                        setShowSearchBar={setShowSearchBar}
                        setCurrentPage={setCurrentPage}
                        searchUserText={searchUserText}
                        setSearchUserText={setSearchUserText}
                        handlePaste={handlePaste}
                        bgColor={"bg-custom-card"}
                        bgHover={"hover:bg-custom-cardHover"}
                        searchBarRefAcc={searchBarRefAcc2}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        typepop={typepop}
                      />
                    )}
                  </>
                  <div
                    className={`beneacc_filter_div ${
                      currentCategory !== "" ||
                      startDateFilter ||
                      endDateFilter ||
                      panNumber ||
                      accountNumber ||
                      isIfsc
                        ? "filtered"
                        : ""
                    }`}
                  >
                    <Tooltip
                      componentsProps={{
                        popper: {
                          sx: {
                            [`& .${tooltipClasses.tooltip}`]: {
                              backgroundColor: (theme) =>
                                theme.palette.common.black,
                            },
                            zIndex: "2147483647 !important",
                          },
                        },
                      }}
                      title="Filters"
                    >
                      <div
                        style={{
                          opacity: showSearchBar ? "0.6" : "1",
                          cursor: showSearchBar ? "default" : "pointer",
                        }}
                        ref={sidebarButtonRef}
                        className={`${
                          typepop === "popup"
                            ? "filter-container_acc"
                            : `filter-container_acc-internal hover:${
                                !showSearchBar ? "bg-Blue_7" : ""
                              }`
                        } `}
                        onClick={() => {
                          if (!showSearchBar) {
                            toggleSidebar();
                          } else if (showSearchBar) {
                            setShowSearchBar(false);
                          }
                        }}
                      >
                        <Box className="filter-box">
                          <img
                            src={isFilterApplied ? FilterBlue : Filter}
                            alt=""
                            className="filter-image"
                          />
                        </Box>
                        <Box className="filter-box">
                          <img
                            src={getArrowIcon(isSidebarOpen, isFilterApplied)}
                            alt=""
                            className="filter-image"
                          />
                        </Box>
                      </div>
                    </Tooltip>
                    <div>
                      <BeneAccFilterSidebar
                        internalAccount={internalAccount}
                        sidebarRef={sidebarRef}
                        isOpen={isSidebarOpen}
                        onClose={toggleSidebar}
                        categoryName={currentCategory}
                        sendCategory={handleFilterCategory}
                        setPage={setCurrentPage}
                        setIsSidebarOpen={setIsSidebarOpen}
                        toggleSidebar={toggleSidebar}
                        initCategory={initCategory}
                        setInitCategory={setInitCategory}
                        handleFilterDateRange={handleFilterDateRange}
                        setEndDateFilter={setEndDateFilter}
                        setStartDateFilter={setStartDateFilter}
                        startDateFilter={startDateFilter}
                        endDateFilter={endDateFilter}
                        setAccountNumber={setAccountNumber}
                        accountNumber={accountNumber}
                        sendAccountNumber={handleAccountSearch}
                        sendPanNumber={handlePanSearch}
                        onPaste={handleAccPaste}
                        panNumber={panNumber}
                        setPanNumber={setPanNumber}
                        searchPanText={searchPanText}
                        setSearchPanText={setSearchPanText}
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        sendIfscNumber={handleIfscSearch}
                        isIfsc={isIfsc}
                        setIsIfsc={setIsIfsc}
                        searchIfscText={searchIfscText}
                        setSearchIfscText={setSearchIfscText}
                        searchAccountText={searchAccountText}
                        setSearchAccountText={setSearchAccountText}
                        showDatePicker={showDatePicker}
                        setShowDatePicker={setShowDatePicker}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        typepop={typepop}
                        tempStartDate={tempStartDate}
                        tempEndDate={tempEndDate}
                        setTempEndDate={setTempEndDate}
                        setTempStartDate={setTempStartDate}
                        balanceType={balanceType}
                        associateAccount={associateAccount}
                        associatepanNumber={associatepanNumber}
                        associateIFSC={associateIFSC}
                        associateaccountNumber={associateaccountNumber}
                        setcallFilterFunc={setcallFilter}
                        callFilterFunc={callFilter}
                        isInternalFilter={isInternalFilter}
                        setIsInternalFilter={setIsInternalFilter}
                        setFilterStatus={setFilterStatus}
                        BeneTxnAssocAcct={BeneTxnAssocAcct}
                        dateRef={dateRef}
                        associateTxn={associateTxn}
                        flow={flow}
                      />
                    </div>
                  </div>

                  <div
                    className="bene_txn_viewall_toggle_containers_acc"
                    style={{
                      opacity: isSidebarOpen || showSearchBar ? "0.6" : "1",
                      cursor:
                        isSidebarOpen || showSearchBar ? "default" : "pointer",
                    }}
                  >
                    <Tooltip
                      componentsProps={{
                        popper: {
                          sx: {
                            [`& .${tooltipClasses.tooltip}`]: {
                              backgroundColor: (theme) =>
                                theme.palette.common.black,
                            },
                            zIndex: "2147483647 !important",
                          },
                        },
                      }}
                      title="Grid"
                    >
                      <Box
                        onClick={() => {
                          if (isSidebarOpen) {
                            setIsSidebarOpen(false);
                          } else if (showSearchBar) {
                            setShowSearchBar(false);
                          }
                          handleToggle(false);
                        }}
                        sx={{
                          backgroundColor: toggle ? "" : "var(--Primary_white)",
                        }}
                        className={`toggle-box`}
                      >
                        <img
                          src={toggle ? GridWhite : GridBlue}
                          alt=""
                          className="toggle-images"
                        />
                      </Box>
                    </Tooltip>
                    <Tooltip
                      componentsProps={{
                        popper: {
                          sx: {
                            [`& .${tooltipClasses.tooltip}`]: {
                              backgroundColor: (theme) =>
                                theme.palette.common.black,
                            },
                            zIndex: "2147483647 !important",
                          },
                        },
                      }}
                      title="List"
                    >
                      <Box
                        onClick={() => {
                          if (isSidebarOpen) {
                            setIsSidebarOpen(false);
                          } else if (showSearchBar) {
                            setShowSearchBar(false);
                          }
                          handleToggle(true);
                        }}
                        sx={{
                          backgroundColor: toggle ? "var(--Primary_white)" : "",
                        }}
                        className={`toggle-box `}
                      >
                        <img
                          src={toggle ? ListBlue : ListWhite}
                          alt=""
                          className="toggle-images"
                        />
                      </Box>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            {(currentCategory !== "" ||
              panNumber !== "" ||
              accountNumber !== "" ||
              isIfsc !== "" ||
              (startDateFilter !== "" &&
                endDateFilter !== "" &&
                startDateFilter !== 0 &&
                endDateFilter !== 0 &&
                !isNaN(Number(startDateFilter)) &&
                !isNaN(Number(endDateFilter)))) && (
              <div
                className="bene_acc_filterdropdown-container-div"
                style={{
                  width: typepop === "popup" ? "96%" : "100%",
                  top: typepop === "popup" ? "4%" : "0",
                  left: typepop === "popup" ? "2%" : "0",
                  marginTop: showSearchBar ? "245px" : "170px",
                }}
              >
                <div className="bene_acc_filterdropdown">
                  <div
                    style={{
                      display: "flex",
                      // width: "45%",
                    }}
                  >
                    <div className="filter--div--left">
                      <p className="pr-2">Filtered by : </p>
                      {currentCategory && (
                        <div className="filter-body px-2 h-[16px]">
                          <div className="img-div">
                            <img src={rentalImg} alt={currentCategory} />
                          </div>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                  zIndex: "2147483647 !important",
                                },
                              },
                            }}
                            title={currentCategory}
                          >
                            <p className="px-2 text-xs truncate w-[100px] h-[16px]">
                              {currentCategory}
                            </p>
                          </Tooltip>
                          <div
                            className="close-btn"
                            onClick={handleFilterSticker}
                            style={{ cursor: "pointer" }}
                          >
                            {" "}
                            <img src={closeBtnImg} alt="close-btn" />
                          </div>
                        </div>
                      )}
                      {panNumber && (
                        <div
                          className="filter-body px-2"
                          style={{
                            opacity:
                              balanceType === "Pan" &&
                              (associateAccount ||
                                BeneTxnAssocAcct ||
                                associateTxn === "associateTxn")
                                ? "0.6"
                                : "1",
                            pointerEvents:
                              balanceType === "Pan" &&
                              (associateAccount ||
                                BeneTxnAssocAcct ||
                                associateTxn === "associateTxn")
                                ? "none"
                                : "auto",
                          }}
                        >
                          <p className="px-2">{panNumber}</p>
                          <div
                            className="close-btn"
                            onClick={() => {
                              handleFilterPanSticker();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {" "}
                            <img src={closeBtnImg} alt="close-btn" />
                          </div>
                        </div>
                      )}

                      {accountNumber && (
                        <div
                          className="filter-body px-2"
                          style={{
                            opacity:
                              balanceType === "Bank" &&
                              (associateAccount || BeneTxnAssocAcct)
                                ? "0.6"
                                : "1",
                            pointerEvents:
                              balanceType === "Bank" &&
                              (associateAccount || BeneTxnAssocAcct)
                                ? "none"
                                : "auto",
                          }}
                        >
                          <p className="px-2">
                            {" "}
                            {accountNumber &&
                              formatAccountNumber(accountNumber)}
                          </p>
                          <div
                            className="close-btn"
                            onClick={() => {
                              handleFilterAccountSticker();
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {" "}
                            <img src={closeBtnImg} alt="close-btn" />
                          </div>
                        </div>
                      )}
                      {startDateFilter !== "" &&
                        endDateFilter !== "" &&
                        startDateFilter !== 0 &&
                        endDateFilter !== 0 &&
                        !isNaN(Number(startDateFilter)) &&
                        !isNaN(Number(endDateFilter)) && (
                          <div className="filter-body px-2">
                            <div className="px-2">
                              {formatDate(new Date(startDateFilter))}
                            </div>
                            <img
                              src={arrowForward}
                              className="bene_acc_viewall_calendar_icon"
                            />
                            <div className="px-2">
                              {formatDate(new Date(endDateFilter))}
                            </div>
                            <div
                              className="close-btn"
                              onClick={() => {
                                handleFilterDateSticker();
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {" "}
                              <img src={closeBtnImg} alt="close-btn" />
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!toggle ? (
              <div
                ref={scrollContainerRef}
                tabIndex="0"
                id="infinityScrollContainerBeneView"
                className={
                  typepop === "popup"
                    ? "infinityScrollContainerAccBeneView"
                    : ""
                }
                style={{
                  overflow: !isWheelScrolling && "hidden",
                  marginBottom: !isWheelScrolling && "0px",
                  marginTop:
                    isFilterActive && !showSearchBar
                      ? "254px"
                      : isFilterActive &&
                        showSearchBar &&
                        (associateAccount ||
                          BeneTxnAssocAcct ||
                          associateTxn === "associateTxn")
                      ? "330px" //DFFG
                      : isFilterActive && showSearchBar
                      ? "335px" //DFFG
                      : showSearchBar
                      ? "252px"
                      : "175px",
                }}
                onKeyDown={(event) => {
                  if (
                    event.key === "w" ||
                    event.key === "s" ||
                    event.key === "W" ||
                    event.key === "S" ||
                    event.code == "KeyS" ||
                    event.code == "KeyW" ||
                    event.key === "ArrowUp" ||
                    event.key === "ArrowDown"
                  ) {
                    event.preventDefault();

                    return false;
                  }
                }}
              >
                {loading ? (
                  <div
                    className="loader-container grid place-items-center absolute w-full h-full"
                    style={{ top: typepop === "popup" ? "-8vh" : "156px" }}
                  >
                    <Loader />
                  </div>
                ) : filteredData?.length > 0 ? (
                  <div
                    className={`scroll flex flex-col items-center justify-center w-full ${
                      isSidebarOpen && "overflow-y-hidden"
                    }`}
                    ref={filterRef}
                  >
                    <BeneViewAllCard
                      data={filteredData}
                      lastElementRef={lastElementRef}
                      isSidebarOpen={isSidebarOpen}
                      typepop={typepop}
                      handleButtonClick={handleButtonClick}
                      internalAccount={internalAccount}
                      associateaccountNumber={associateaccountNumber}
                      associateAccount={associateAccount}
                      setOpenInternalAssociate={setOpenInternalAssociate}
                      balanceType={balanceType}
                      setOpenBeneAssociate={setOpenBeneAssociate}
                      associatepanNumber={associatepanNumber}
                      showSearchBar={showSearchBar}
                      beneAccountId={beneAccountId}
                      txnPayLoad={txnPayLoad}
                      setTxnPayLoad={setTxnPayLoad}
                      setIsImps={setIsImps}
                      setIsNeft={setIsNeft}
                      onClosepop={onClosepop}
                      setIsRtgs={setIsRtgs}
                      accountType={accountType}
                      BeneTxnAssocAcct={BeneTxnAssocAcct}
                      setAssociateModalOpen={setAssociateModalOpen}
                      associateTxn={associateTxn}
                      flow={
                        flow === "internalTxn"
                          ? "internalTxn"
                          : "Internal_Account"
                      }
                    />
                  </div>
                ) : accumulatedData?.length === 0 &&
                  filteredData?.length === 0 &&
                  !loading ? (
                  <div
                    className="flex flex-col items-center justify-center m-auto w-full h-full"
                    style={{
                      marginTop:
                        typepop === "popup" && !showSearchBar
                          ? "-6vh"
                          : typepop === "popup" && showSearchBar
                          ? "-5vh"
                          : "",
                      height:
                        typepop === "popup" && !showSearchBar
                          ? ""
                          : typepop === "popup" && showSearchBar
                          ? "100%"
                          : "",
                      overflowY: showSearchBar && "scroll",

                      paddingBottom: "12vh",
                      paddingTop:
                        associateTxn === "associateTxn" ||
                        associateAccount ||
                        BeneTxnAssocAcct
                          ? "10vh"
                          : "10vh",
                    }}
                  >
                    <img
                      src={noaccount}
                      alt="No accounts found"
                      className="bene-acc-no-acc-image"
                      style={{
                        height:
                          typepop === "popup" && showSearchBar
                            ? "220px"
                            : "230px",
                      }}
                    />
                    <p className="bene-acc-no-beneaccount-text">
                      No accounts found.
                    </p>
                  </div>
                ) : (
                  <div
                    className="loader-container grid place-items-center absolute w-full h-full"
                    style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
                  >
                    <Loader />
                  </div>
                )}

                {(currentStatus === "" || currentStatus === "all") && (
                  <div ref={lastElementRef}></div>
                )}
              </div>
            ) : (
              <div
                ref={scrollContainerRef}
                id="infinityScrollContainerBeneView"
                className={
                  typepop === "popup"
                    ? "infinityScrollContainerAccBeneView"
                    : ""
                }
                onKeyDown={(event) => {
                  if (
                    event.key === "w" ||
                    event.key === "s" ||
                    event.key === "W" ||
                    event.key === "S" ||
                    event.code == "KeyS" ||
                    event.code == "KeyW" ||
                    event.keyCode === "83" ||
                    event.keyCode === "87" ||
                    event.key === "ArrowUp" ||
                    event.key === "ArrowDown"
                  ) {
                    event.stopPropagation();
                    event.preventDefault();

                    return false;
                  }
                  event.stopPropagation();
                }}
                style={{
                  marginTop:
                    isFilterActive && !showSearchBar
                      ? "254px"
                      : isFilterActive &&
                        showSearchBar &&
                        associateAccount &&
                        associateTxn === "associateTxn"
                      ? "325px"
                      : isFilterActive && showSearchBar
                      ? "335px"
                      : showSearchBar
                      ? "252px"
                      : "175px",
                }}
              >
                {loading ? (
                  <div
                    className="loader-container grid place-items-center absolute w-full h-full"
                    style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
                  >
                    <Loader />
                  </div>
                ) : filteredData?.length > 0 ? (
                  <div
                    className={`scroll flex flex-col items-center justify-center w-full ${
                      isSidebarOpen && "overflow-y-hidden"
                    }`}
                    ref={filterRef}
                  >
                    <BeneAccListView
                      data={accumulatedData}
                      isSidebarOpen={isSidebarOpen}
                      page={currentPage}
                      isPopoverOpen={isPopoverOpen}
                      typepop={typepop}
                      handleButtonClick={handleButtonClick}
                      pageSize={pageSize}
                      internalAccount={internalAccount}
                      associateAccount={associateAccount}
                      setOpenInternalAssociate={setOpenInternalAssociate}
                      balanceType={balanceType}
                      associatepanNumber={associatepanNumber}
                      showSearchBar={showSearchBar}
                      beneAccountId={beneAccountId}
                      txnPayLoad={txnPayLoad}
                      setTxnPayLoad={setTxnPayLoad}
                      setIsNeft={setIsNeft}
                      setIsImps={setIsImps}
                      setIsRtgs={setIsRtgs}
                      onClosepop={onClosepop}
                      flow={flow}
                      accountType={accountType}
                      setOpenBeneAssociate={setOpenBeneAssociate}
                      setAssociateModalOpen={setAssociateModalOpen}
                      BeneTxnAssocAcct={BeneTxnAssocAcct}
                    />
                  </div>
                ) : accumulatedData?.length === 0 &&
                  filteredData?.length === 0 &&
                  !loading ? (
                  <div
                    className="flex flex-col items-center justify-center m-auto w-full h-full"
                    style={{
                      marginTop:
                        typepop === "popup" && !showSearchBar
                          ? "-6vh"
                          : typepop === "popup" && showSearchBar
                          ? "-5vh"
                          : "",
                      height:
                        typepop === "popup" && !showSearchBar
                          ? ""
                          : typepop === "popup" && showSearchBar
                          ? "100%"
                          : "",
                      overflowY: showSearchBar && "scroll",

                      paddingBottom: "12vh",
                      paddingTop:
                        associateTxn === "associateTxn" ||
                        associateAccount ||
                        BeneTxnAssocAcct
                          ? "10vh"
                          : "10vh",
                    }}
                  >
                    <img
                      src={noaccount}
                      alt="No accounts found"
                      className="bene-acc-no-acc-image"
                    />
                    <p className="bene-acc-no-beneaccount-text">
                      No accounts found.
                    </p>
                  </div>
                ) : (
                  <div
                    className="loader-container grid place-items-center absolute w-full h-full"
                    style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
                  >
                    <Loader />
                  </div>
                )}

                {(currentStatus === "" || currentStatus === "all") && (
                  <div ref={lastElementRef}></div>
                )}
              </div>
            )}
          </div>
        </>
      </div>

      <div
        id="mobileviewd"
        style={{
          overflow: "hidden",
          position: "relative",
          overflowY: isSidebarOpenm || isPopoverOpenm ? "hidden" : "",
          height: isSidebarOpenm || isPopoverOpenm ? "100vh" : "100%",
        }}
      >
        {isPopoverOpenm && <div className="acc_black_divm"></div>}
        {isSidebarOpenm && <div className="acc_black_divm"></div>}
        {
          <div
            style={{
              zIndex: isSidebarOpenm ? "0" : "9999",
              width: "100%",
              bottom: "0",
              borderRadius: "0",
              opacity: isSidebarOpenm || isPopoverOpenm ? 0.1 : 1,
            }}
            className="fixed w-full bg-Blue_4 h-[50px]"
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
            />
          </div>
        }
        <div className="beneacc_approval_heder_containermv">
          <div className="benetxn_approval_heder_containermv"></div>
        </div>
        <div className="beneacc_approval_heder_containermv">
          <div
            className="txnBeneapprovalheadertextv"
            style={{ padding: typepop === "popup" ? "10px" : "10px" }}
          >
            <div className="txnBeneapprovalheadertextmv">
              <div>
                <div
                  className="w-[16px] h-[16px] flex items-center justify-center"
                  onClick={() => {
                    if (flow === "internalTxn") {
                      onClosepop();
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  <img src={ArrowLeft} alt="ArrowLeft" />
                </div>
              </div>
              <div>
                {internalAccount === "internalAccount" ? (
                  <>
                    <div className="headingAccountDetail">Internal</div>
                    <div className="headertextbottomv">Account</div>
                  </>
                ) : typepop === "popup" ? (
                  <>
                    {isFilterActive ? (
                      <div className="headingAccountDetail">
                        Associated Accounts
                      </div>
                    ) : flow === "internalTxn" ? (
                      <div className="headingAccountDetail">
                        Select Destination Account
                      </div>
                    ) : (
                      <div className="headingAccountDetail">
                        Select Beneficiary Account
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div
              className="txnBeneapprovalheaderfilterv"
              style={{ width: "40px" }}
            >
              <div className="txnimgfmv" style={{ marginLeft: 0 }}>
                <div className="txnimgfv">
                  <div
                    ref={sidebarRefm}
                    className={`beneacc_filter_divm ${
                      isFilterApplied ? "filtered" : ""
                    }`}
                  >
                    <Tooltip
                      componentsProps={{
                        popper: {
                          sx: {
                            [`& .${tooltipClasses.tooltip}`]: {
                              backgroundColor: (theme) =>
                                theme.palette.common.black,
                            },
                            zIndex: "2147483647 !important",
                          },
                        },
                      }}
                      title="Filters"
                    >
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSidebarm();
                          setShowSearchBarm(false);
                        }}
                      >
                        <img
                          src={isFilterApplied ? FilterBlue : Filter}
                          alt=""
                          className="w-[16px] h-[16px] ml-[7px]"
                        />
                      </Box>
                    </Tooltip>
                    <BeneAccFilterSidebar
                      balanceType={"Pan"}
                      internalAccount={internalAccount}
                      isOpen={isSidebarOpenm}
                      onClose={toggleSidebarm}
                      categoryName={currentCategory}
                      sendCategory={handleFilterCategory}
                      setPage={setCurrentPage}
                      setIsSidebarOpenm={setIsSidebarOpenm}
                      toggleSidebarm={toggleSidebarm}
                      initCategory={initCategory}
                      setInitCategory={setInitCategory}
                      sendDateRange={handleFilterDateRange}
                      setEndDateFilter={setEndDateFilter}
                      setStartDateFilter={setStartDateFilter}
                      setAccountNumber={setAccountNumber}
                      accountNumber={accountNumber}
                      sendAccountNumber={handleAccountSearch}
                      sendPanNumber={handlePanSearch}
                      onPaste={handleAccPaste}
                      panNumber={panNumber}
                      setPanNumber={setPanNumber}
                      searchPanText={searchPanText}
                      setSearchPanText={setSearchPanText}
                      startDate={startDate}
                      endDate={endDate}
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      sendIfscNumber={handleIfscSearch}
                      isIfsc={isIfsc}
                      setIsIfsc={setIsIfsc}
                      searchIfscText={searchIfscText}
                      setSearchIfscText={setSearchIfscText}
                      searchAccountText={searchAccountText}
                      setSearchAccountText={setSearchAccountText}
                      showDatePicker={showDatePicker}
                      setShowDatePicker={setShowDatePicker}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      startDateFilter={startDateFilter}
                      endDateFilter={endDateFilter}
                      tempStartDate={tempStartDate}
                      tempEndDate={tempEndDate}
                      setTempEndDate={setTempEndDate}
                      setTempStartDate={setTempStartDate}
                      setFilterStatus={setFilterStatus}
                      BeneTxnAssocAcct={BeneTxnAssocAcct}
                      dateRef={dateRef}
                      flow={flow}
                      associateTxn={associateTxn}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isSidebarOpenm && (
          <div
            className="accBeneapprovalheadertextvcv bg-black"
            style={{
              borderBottom: isPopoverOpenm ? "none" : "3px solid var(--Blue_3)",
              marginTop: isFilterActive ? "80px" : "66px",
            }}
          >
            <div
              className="beneaccViewAllParentdivm"
              style={{
                zIndex: isPopoverOpenm ? 99999 : 0,
              }}
            >
              <div className="beneTxnViewAllchild1">
                <AllStatusTypeButtonMob
                  getAccStatus={getAccStatus}
                  selectedStatus={currentStatus}
                  setPage={setCurrentPage}
                  setIsPopoverOpenm={setIsPopoverOpenm}
                  isPopoverOpenm={isPopoverOpenm}
                  isStatusSelected={isStatusSelected}
                  setIsStatusSelected={setIsStatusSelected}
                  setShowSearchBar={setShowSearchBar}
                  internalAccount={internalAccount}
                />
              </div>
            </div>
          </div>
        )}

        {(currentCategory !== "" ||
          panNumber !== "" ||
          accountNumber !== "" ||
          isIfsc !== "" ||
          (startDateFilter !== "" && endDateFilter !== "")) &&
          showSearchBarm === false && (
            <div
              className="bene_acc_filterdropdown-container-divm"
              style={{
                zIndex: isPopoverOpenm ? 0 : 4,
              }}
            >
              <div className="bene_acc_filterdropdown">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    overflow: "auto",
                    padding: "0px 20px",
                  }}
                >
                  <div className="filter--div--left">
                    <p className="pr-2" style={{ width: "90px" }}>
                      Filtered by :
                    </p>
                    {currentCategory && (
                      <div className="filter-body flex items-center px-2 h-[16px]">
                        <div className="img-div">
                          <img src={rentalImg} alt={currentCategory} />
                        </div>
                        <Tooltip
                          componentsProps={{
                            popper: {
                              sx: {
                                [`& .${tooltipClasses.tooltip}`]: {
                                  backgroundColor: (theme) =>
                                    theme.palette.common.black,
                                },
                                zIndex: "2147483647 !important",
                              },
                            },
                          }}
                          title={currentCategory}
                        >
                          <p className="px-2 text-xs truncate w-[100px] h-[16px] text-center">
                            {currentCategory}
                          </p>
                        </Tooltip>
                        <div
                          className="close-btn"
                          onClick={handleFilterSticker}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={closeBtnImg} alt="close-btn" />
                        </div>
                      </div>
                    )}
                    {panNumber && (
                      <div
                        className="filter-body flex items-center justify-center px-2"
                        style={{
                          opacity:
                            balanceType === "Pan" &&
                            (associateAccount ||
                              BeneTxnAssocAcct ||
                              associateTxn === "associateTxn")
                              ? "0.6"
                              : "1",
                          pointerEvents:
                            balanceType === "Pan" &&
                            (associateAccount ||
                              BeneTxnAssocAcct ||
                              associateTxn === "associateTxn")
                              ? "none"
                              : "auto",
                        }}
                      >
                        <p className="px-2 text-center">{panNumber}</p>
                        <div
                          className="close-btn"
                          onClick={() => {
                            handleFilterPanSticker();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={closeBtnImg} alt="close-btn" />
                        </div>
                      </div>
                    )}
                    {accountNumber && (
                      <div
                        className="filter-bodydiv flex justify-between  w-[240px] px-4"
                        style={{
                          opacity:
                            balanceType === "Bank" &&
                            (associateAccount || BeneTxnAssocAcct)
                              ? "0.6"
                              : "1",
                          pointerEvents:
                            balanceType === "Bank" &&
                            (associateAccount || BeneTxnAssocAcct)
                              ? "none"
                              : "auto",
                        }}
                      >
                        <p className="">
                          {accountNumber && formatAccountNumber(accountNumber)}
                        </p>
                        <div
                          className="close-btn"
                          onClick={() => {
                            handleFilterAccountSticker();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={closeBtnImg} alt="close-btn" />
                        </div>
                      </div>
                    )}
                    {startDateFilter !== "" &&
                      endDateFilter !== "" &&
                      startDateFilter !== 0 &&
                      endDateFilter !== 0 &&
                      !isNaN(Number(startDateFilter)) &&
                      !isNaN(Number(endDateFilter)) && (
                        <div className="filter-bodydiv flex items-center justify-between  px-4 w-[295px]">
                          <div className="">
                            {formatDate(new Date(startDateFilter))}
                          </div>
                          <img
                            src={arrowForward}
                            className="bene_acc_viewall_calendar_icon"
                          />
                          <div className="px-2 text-center">
                            {formatDate(new Date(endDateFilter))}
                          </div>
                          <div
                            className="close-btn"
                            onClick={() => {
                              handleFilterDateSticker();
                            }}
                            style={{ cursor: "pointer", marginRight: "" }}
                          >
                            <img src={closeBtnImg} alt="close-btn" />
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}
        {!toggle ? (
          <div
            id={`infinityScrollContainerBeneView${
              accumulatedData?.length === 0 && filteredData?.length === 0
                ? "_beneemptyDataClass"
                : ""
            }`}
            className={
              typepop === "popup" ? "infinityScrollContainerAccBeneView" : ""
            }
            style={{
              marginTop:
                currentCategory !== "" ||
                panNumber !== "" ||
                accountNumber !== "" ||
                isIfsc !== "" ||
                (startDateFilter !== "" && endDateFilter !== "")
                  ? "247px"
                  : showSearchBar
                  ? "267px"
                  : typepop === "popup"
                  ? "148px"
                  : "170px",
              height:
                currentCategory !== "" ||
                panNumber !== "" ||
                accountNumber !== "" ||
                isIfsc !== "" ||
                (startDateFilter !== "" && endDateFilter !== "")
                  ? "62vh"
                  : "62vh",
            }}
          >
            {loading ? (
              <div
                className="loader-container grid place-items-center absolute w-full h-screen"
                style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
              >
                <Loader />
              </div>
            ) : filteredData?.length > 0 ? (
              <div
                className={`scroll flex flex-col justify-center w-full ${
                  isSidebarOpen && "overflow-y-hidden"
                }`}
                ref={filterRef}
              >
                {typepop === "popup" ? (
                  <>
                    <p className="font-open-sans text-[12px] p-1 mx-4 leading-[16.34px] text-Primary_white">
                      Only active (pending & approved) accounts are enabled for
                      selection.
                    </p>
                  </>
                ) : (
                  <></>
                )}

                <BeneViewAllCard
                  data={filteredData}
                  lastElementRef={lastElementRef}
                  isSidebarOpen={isSidebarOpen}
                  typepop={typepop}
                  handleButtonClick={handleButtonClick}
                  internalAccount={internalAccount}
                  beneAccountId={beneAccountId}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  setAssociateModalOpen={setAssociateModalOpen}
                  associateaccountNumber={associateaccountNumber}
                  associateAccount={associateAccount}
                  setOpenInternalAssociate={setOpenInternalAssociate}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsNeft={setIsNeft}
                  setIsImps={setIsImps}
                  setIsRtgs={setIsRtgs}
                  onClosepop={onClosepop}
                  balanceType={balanceType}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  associatepanNumber={associatepanNumber}
                  showSearchBar={showSearchBar}
                  accountType={accountType}
                  onClose={onClose}
                  associateTxn={associateTxn}
                  flow={
                    flow === "internalTxn" ? "internalTxn" : "Internal_Account"
                  }
                />
              </div>
            ) : accumulatedData?.length === 0 &&
              filteredData?.length === 0 &&
              !loading ? (
              <div
                className="flex flex-col items-center w-full h-full justify-center"
                style={{ marginTop: typepop === "popup" ? "-4vh" : "" }}
              >
                <img
                  src={noaccount}
                  alt="No accounts found"
                  className="bene-acc-no-acc-image"
                />
                <p className="bene-acc-no-beneaccount-text">
                  No accounts found.
                </p>
              </div>
            ) : (
              <div
                className="loader-container grid place-items-center absolute w-full h-full"
                style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
              >
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            id={`infinityScrollContainerBeneView${
              accumulatedData?.length === 0 && filteredData?.length === 0
                ? "_beneemptyDataClass"
                : ""
            }`}
            className={
              typepop === "popup" ? "infinityScrollContainerAccBeneView" : ""
            }
            style={{
              marginTop:
                currentCategory !== "" ||
                panNumber !== "" ||
                accountNumber !== "" ||
                isIfsc !== "" ||
                (startDateFilter !== "" && endDateFilter !== "")
                  ? "285px"
                  : showSearchBar
                  ? "268px"
                  : "198px",
              height:
                currentCategory !== "" ||
                panNumber !== "" ||
                accountNumber !== "" ||
                isIfsc !== "" ||
                (startDateFilter !== "" && endDateFilter !== "")
                  ? "57vh"
                  : "57vh",
              overflowX: "hidden",
            }}
          >
            {loading ? (
              <div
                className="loader-container grid place-items-center absolute w-full h-full"
                style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
              >
                <Loader />
              </div>
            ) : filteredData?.length > 0 ? (
              <div
                className={`scroll flex flex-col items-center justify-center w-full ${
                  isSidebarOpen && "overflow-y-hidden"
                }`}
                ref={filterRef}
              >
                <BeneAccListView
                  data={accumulatedData}
                  isSidebarOpen={isSidebarOpen}
                  page={currentPage}
                  isPopoverOpen={isPopoverOpen}
                  internalAccount={internalAccount}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsNeft={setIsNeft}
                  setIsImps={setIsImps}
                  setIsRtgs={setIsRtgs}
                  onClosepop={onClosepop}
                  flow={flow}
                  lastElementRef={lastElementRef}
                  typepop={typepop}
                  handleButtonClick={handleButtonClick}
                  beneAccountId={beneAccountId}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  setAssociateModalOpen={setAssociateModalOpen}
                  associateTxn={associateTxn}
                />
              </div>
            ) : accumulatedData?.length === 0 &&
              filteredData?.length === 0 &&
              !loading ? (
              <div
                className="flex flex-col items-center w-full h-full justify-center"
                style={{ marginTop: typepop === "popup" ? "-4vh" : "" }}
              >
                <img
                  src={noaccount}
                  alt="No accounts found"
                  className="bene-acc-no-acc-image"
                />
                <p className="bene-acc-no-beneaccount-text">
                  No accounts found.
                </p>
              </div>
            ) : (
              <div
                className="loader-container grid place-items-center absolute w-full h-full"
                style={{ top: typepop === "popup" ? "-8vh" : "56px" }}
              >
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InternalAccountViewAll;
